import React, {Component} from "react";
import cornerstone from 'cornerstone-core';
import {NotificationManager} from "react-notifications";
import {Button} from '@mui/material';
import classNames from 'classnames';
import JSONParseDefault from 'json-parse-default';
import * as Apis from 'Api';
import {connect} from "react-redux";
import {changeHangingLayout, setImageAnswer} from "Store/Actions";
import {getAttemptPollAnswer} from "Api";

class PollQuestions extends Component {
    constructor(props) {
        super(props);
        this.state = {
            questionList: [],
            socket: this.props.socket
        }
    }


    componentDidMount() {
        this.getData();
    }

    getData() {
        Apis.getAttemptPollAnswer(this.props.attempts_id, this.props.test_case_id, this.props.isPostTest).then((resp) => {
            this.setState({questionList: resp});
        }).catch((error) => {
            NotificationManager.error(error.response ? error.response.data.error.message : error.message);
        });
    }

    containsValue(obj, value) {
        for (let key in obj) {
            if (obj[key].includes(value)) {
                return true;
            }
        }
        return false;
    }

    onSelectAnswer(qIndex, oId) {
        const {questionList} = this.state;
        let answerOptions = questionList[qIndex].answerOptionId;
        if(!answerOptions) answerOptions = [];
        if(typeof answerOptions === 'string') {
            answerOptions = [answerOptions];
        }
        const i = answerOptions.indexOf(oId);
        if(i === -1) {
            answerOptions.push(oId);
        } else {
            answerOptions.splice(i, 1);
        }
        questionList[qIndex].answerOptionId = answerOptions;
        this.setState({questionList: [...questionList]});
        const answerObj = {};
        questionList.forEach((v) => {
            if (v.answerOptionId) answerObj[v.id] = v.answerOptionId;
        });
        Apis.setAttemptImageQuality(this.props.attempts_id, this.props.test_case_id, answerObj, this.props.isPostTest).then(resp => {
            const result = this.containsValue(answerObj, oId);
            const { socket } = this.state;
            // const answerOptionIds = this.state.questionList.map(item => item.answerOptionId).flat();
            // console.log(answerOptionIds);
            if (socket) {
                socket.send(JSON.stringify({ type: 'message', room: this.props.test_set_id, messageType: 'answer', messageData: {id: oId, state: result} }));
            }
        }).catch(error => {
            NotificationManager.error(error.response ? error.response.data.error.message : error.message);
        });
    }

    renderQuestion(question, questionIndex) {
        return (
            <div className={'quiz-question-item'} key={questionIndex}>
                <div className={'quiz-title'}>
                    {/*<div>{question.question} </div>*/}
                    <div dangerouslySetInnerHTML={{__html: question.question}}/>
                </div>
                {
                    (question.isAnnotation && question.answerAnnotationCorrect !== undefined) &&
                    <div className={'fs-15 text-lightyellow ps-2'}>{question.answerAnnotationCorrect ? 'Correct' : 'Incorrect'}</div>
                }
                <div className={'quiz-option-list'}>
                    {
                        question.optionList.map((option, optionIndex) => (
                            <div key={option.id}>
                                <Button
                                    className={classNames('quiz-option', {'selected': question.answerOptionId && question.answerOptionId.includes(option.id)}, {'truth': this.props.isShowAnswers && question.truthOptionId && question.truthOptionId.includes(option.id)})}
                                    onClick={() => this.onSelectAnswer(questionIndex, option.id)}
                                >
                                    <div dangerouslySetInnerHTML={{__html: option.value}}/>
                                </Button>
                            </div>
                        ))
                    }
                </div>
            </div>
        )
    }

    render() {
        return (
            <div className={'covid-question-container chest-data'}>
                <div className={'d-flex flex-column'} style={{flex: 1}}>
                    <div className={'quiz-question-container'}>
                        {this.state.questionList.map((v, i) => this.renderQuestion(v, i))}
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        selectedHangingType: state.testView.selectedHangingType,
    };
};

export default connect(mapStateToProps, {
    setImageAnswer,
    changeHangingLayout
}, null, {forwardRef: true})(PollQuestions);
